//#region Imports
import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';

import { getToast } from '../../utils/toastConfig';
import { GlobalVariables } from '../../globalVar';
import customAxios from '../../utils/customAxios';
import { SurveysTable } from '../../components/Tables/Sigma/SurveysTable';
//#endregion

const HEADERS = {
  headers: {
    Authorization: 'bearer ' + localStorage.getItem('token'),
  },
};

const Surveys = () => {
  const [isFetching, setIsFetching] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsFetching(true);
    try {
      const endpoint = `${GlobalVariables.getURL()}surveys`;
      const response = await customAxios.get(endpoint, HEADERS);

      if (response.status === 204) {
        setData([]);
        return;
      }

      console.log('🚀 ~ response:', response.data);
      setData(response.data);
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <div className='table-module-container'>
      <Helmet>DABI | Encuestas</Helmet>
      <div className='datatable'>
        <SurveysTable
          data={data}
          isFetching={isFetching}
          fetchData={fetchData}
        />
      </div>
    </div>
  );
};

export default Surveys;
